<script>
  let {
    placeholder = '로손 편의점 1500엔...',
    onSubmit = null,
    loading = false,
  } = $props();

  let value = $state('');

  function handleKeydown(e) {
    if (e.key === 'Enter' && !e.shiftKey && value.trim() && onSubmit) {
      e.preventDefault();
      onSubmit(value.trim());
      value = '';
    }
  }

  function handleSubmit() {
    if (value.trim() && onSubmit) {
      onSubmit(value.trim());
      value = '';
    }
  }
</script>

<div class="receipt-input">
  <div class="receipt-input__field-wrap">
    {#if loading}
      <div class="receipt-input__loading">PROCESSING...</div>
    {:else}
      <input
        type="text"
        class="receipt-input__field"
        {placeholder}
        bind:value
        onkeydown={handleKeydown}
        disabled={loading}
      />
      {#if value.trim()}
        <button class="receipt-input__submit" onclick={handleSubmit} type="button">
          ↵
        </button>
      {/if}
    {/if}
  </div>
  <span class="receipt-input__hint">자연어로 경비를 입력하세요</span>
</div>

<style>
  .receipt-input {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .receipt-input__field-wrap {
    position: relative;
    display: flex;
    align-items: center;
  }

  .receipt-input__field {
    width: 100%;
    font-family: var(--font-mono);
    font-size: var(--receipt-size-body, 13px);
    color: var(--receipt-text-primary);
    background: var(--receipt-bg);
    border: 1px dashed var(--receipt-divider-strong);
    border-radius: 2px;
    padding: 10px 36px 10px 12px;
    outline: none;
    letter-spacing: 0.5px;
    caret-color: var(--receipt-text-accent, #20B2AA);
    transition: border-color 0.2s;
  }

  .receipt-input__field::placeholder {
    color: var(--receipt-text-muted);
    opacity: 0.6;
  }

  .receipt-input__field:focus {
    border-color: var(--receipt-text-accent, #20B2AA);
  }

  .receipt-input__submit {
    position: absolute;
    right: 6px;
    font-family: var(--font-mono);
    font-size: 16px;
    color: var(--receipt-text-accent, #20B2AA);
    background: none;
    border: 1px solid var(--receipt-divider);
    border-radius: 2px;
    padding: 2px 8px;
    cursor: pointer;
    line-height: 1;
    transition: opacity 0.15s;
  }

  .receipt-input__submit:hover {
    opacity: 0.7;
  }

  .receipt-input__loading {
    width: 100%;
    font-family: var(--font-mono);
    font-size: var(--receipt-size-body, 13px);
    color: var(--receipt-text-accent, #20B2AA);
    background: var(--receipt-bg);
    border: 1px dashed var(--receipt-divider-strong);
    border-radius: 2px;
    padding: 10px 12px;
    letter-spacing: 2px;
    text-align: center;
    animation: receipt-blink 1s step-end infinite;
  }

  .receipt-input__hint {
    font-family: var(--font-mono);
    font-size: var(--receipt-size-meta, 11px);
    color: var(--receipt-text-muted);
    letter-spacing: 0.5px;
    padding-left: 2px;
  }

  @keyframes receipt-blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.3; }
  }
</style>
